import React from 'react';

interface SubscriptionOverlayProps {
  children: React.ReactNode;
  message?: string;
  blurIntensity?: number;
  className?: string;
}

interface UseSubscriptionOverlayReturn {
  SubscriptionOverlay: React.FC<SubscriptionOverlayProps>;
}

export const useSubscriptionOverlay = (): UseSubscriptionOverlayReturn => {
  const SubscriptionOverlay: React.FC<SubscriptionOverlayProps> = ({
    children,
    // message = "Only for subscribed member",
    // blurIntensity = 3,
    className = ""
  }) => {
    return (
      <div className={`relative ${className}`}>
        {/* Content with blur effect */}
        <div 
          className="filter blur-sm pointer-events-none"
          style={{ filter: 'blur(3px)' }}
          //   style={{ filter: `blur(${blurIntensity}px)` }}
        >
          {children}
        </div>
        
        {/* Overlay with subscription message */}
        <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-80">
          <div className="text-center p-6 bg-white rounded-xl shadow-lg border-2 border-violet-900">
            <div className="text-2xl font-bold text-violet-900 mb-2">
              🔒
            </div>
            <div className="text-lg font-semibold text-gray-800 mb-2">
              Registered Consumers Only
            </div>
            <div className="text-sm text-gray-600">
              Join now to access exclusive benefits.
            </div>
            <button 
              className="mt-4 bg-violet-900 text-white px-6 py-2 rounded-lg hover:bg-blue-900 transition-colors font-medium"
              onClick={() => {
                const signupUrl = process.env.REACT_APP_SIGNUP;
                if (signupUrl) {
                  window.open(signupUrl, '_blank');
                } else {
                  console.error('REACT_APP_SIGNUP environment variable not set');
                }
              }}
            >
              Sign Up Now
            </button>
          </div>
        </div>
      </div>
    );
  };

  return { SubscriptionOverlay };
}; 